import { render, staticRenderFns } from "./Two.vue?vue&type=template&id=7340fa21&scoped=true&"
import script from "./Two.vue?vue&type=script&lang=js&"
export * from "./Two.vue?vue&type=script&lang=js&"
import style0 from "./Two.vue?vue&type=style&index=0&id=7340fa21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340fa21",
  null
  
)

export default component.exports